<template>
  <component :is="tag" :class="$style.component">
    <router-link
      :to="{
        path: image.artist.url,
        query: { slide: query }
      }"
      :class="$style.link"
    >
      <base-image :image="image" :class="$style.image" sizes="100px" />
    </router-link>
    <image-description :image="image" :class="$style.description" />
  </component>
</template>

<script>
import BaseImage from '@/components/base-image'
import ImageDescription from '@/components/image-description'

export default {
  components: {
    BaseImage,
    ImageDescription
  },
  props: {
    image: {
      type: Object
    },
    tag: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      query: this.image.index
    }
  }
}
</script>

<style lang="scss" module>
.component {
  display: inline-block;
  height: 100%;
}

.image {
  height: 100%;
  width: auto;
}

.link {
  display: inline-block;
  height: 100%;

  @media #{$mqHover} {
    &:hover {
      ~ .description {
        opacity: 1;
        visibility: visible;
        transition: opacity var(--short) ease, visibility var(--short) ease;
      }
    }
  }
}

.description {
  opacity: 0;
  visibility: hidden;
  transition: opacity var(--short) ease, visibility var(--short) ease;
}
</style>
